interface BooleanSwitchProps {
  checked: boolean | null | undefined
  onChange: (checked: boolean) => void
  className?: string
}

export default function BooleanSwitch({ checked, onChange, className }: BooleanSwitchProps) {
  const switchClassName = className ? `form-check form-switch ${className}` : "form-check form-switch"

  return (
    <div className={switchClassName}>
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        checked={checked ?? false}
        onChange={(event) => onChange(event.target.checked)}
      />
    </div>
  )
}